module.exports = __webpack_public_path__ + "static/media/vf-button-women-dress-shoes.80107f96.svg";